import { auth } from './auth';
import { chats } from './chats';
import { personas } from './personas';
import { characters } from './characters';
import { users, user } from './users';
import { spotify } from './spotify';
import { playables } from './playables';
import { scenarios } from './scenarios';
import { scenarioDefinitions } from './scenarioDefinitions';
import { preview } from './preview';
import { youtube } from './youtube';
import { messages } from './messages';
import { tags } from './tags';
import { worlds } from './worlds';

export const api = {
  auth,
  chats,
  personas,
  characters,
  users,
  user,
  spotify,
  playables,
  scenarios,
  scenarioDefinitions,
  preview,
  youtube,
  messages,
  tags,
  worlds,
};

export type * from './types'; 
export type * from './scenarios';
export type * from './scenarioDefinitions';
export type * from './chats';
export type * from './personas';
export type * from './characters';
export type * from './youtube';
export type * from './messages';
export type * from './tags';
export type * from './worlds';
